import request from "./axios";
import { getUserInfo } from "@/utils/auth";

/**
 * 获取可购买的活动
 * @param {*} type 活动类型
 * @param {*} courseType 课程类型
 * @param {*} suitableAge 适用年龄
 * @param {*} status 活动状态
 * @param {*} limit 返回数量
 */
export function getActivityList(type, courseType, suitableAge,status, limit) {
    return request({
        url: "/api/teaching/teachingActivity/getActivityList",
        method: "get",
        params: {
            type, courseType, suitableAge,status, limit
        }
    })
}

/**
 * 获取活动信息
 */
export function getActivityDetail(id){
    return request({
        url: "/api/teaching/teachingActivity/getActivityDetail?activityId=" + id,
        method: "get",
    })
}

/**
 * 获取活动支付链接 
 * @param {活动ID} activityId 
 */
export function getBuyLink(activityId) {
    var userInfo = JSON.parse(getUserInfo());
    if(userInfo == null){
        return null
    }
    return (
        "http://www.vcode.fun/static/mobile/landing.html?actId=" +
        activityId +
        "&userId=" +
        userInfo.id
    );
}


// WEBPACK FOOTER //
// ./src/api/buy.js